export const leadLabels = state => (state.metadata && state.metadata.lead_labels ? state.metadata.lead_labels : {});
export const priorityDefinitions = state => (state.metadata && state.metadata.priority_definitions ? state.metadata.priority_definitions : {});
export const searchableColumns = state => (state.metadata && state.metadata.searchable_columns ? state.metadata.searchable_columns : []);
export const systemSettings = state => (state.metadata ? state.metadata.system_settings : []);
export const leadAttributes = (state, getters) => {
   const labels = getters.leadLabels;
   const searchable = getters.searchableColumns;
   return Object.entries(labels).slice().map(([field, label]) => ({
      field,
      label,
      searchable: searchable.indexOf(field) !== -1,
   }));
};
export const loaded = state => state.loaded;
export const fieldDefinitions = state => (state.loaded ? state.metadata.field_definitions : []);
